import React, { FC, useContext, useMemo, Fragment } from 'react';
import { Page } from 'components/layout/panel/Page/Page';
import { LocaleContext } from 'context/locale';
import { BrowserPrinterList } from './BrowserPrinterRegister/BrowserPrinterList';
import { TabPanel } from 'components/shared/surfaces/TabPanel/TabPanel';
import { Breadcrumb } from 'components/shared/navigation/Breadcrumbs/Breadcrumb';
import { Paper } from 'components/shared/surfaces/Paper/Paper';
import { useStyles } from 'views/Panel/Reports/SchoolStat/SchoolStat.styles';
import { UserPersonalDataChangeRegisterList } from './UserPersonalDataChangeRegister/UserPersonalDataChangeRegisterList';
import { StudentChildDataChangeRegisterList } from './StudentChildDataChangeRegister/StudentChildDataChangeRegisterList';

export const AccessListContainer: FC = () => {
  const { trans } = useContext(LocaleContext);
  const classes = useStyles();

  const tabs = useMemo(() => {
    return [
      {
        title: trans('PERSONAL_DATA_ACCESS.TAB.TITLE.STUDENT_CHILD_REGISTER'),
        key: 'studentChildRegister',
        content: <StudentChildDataChangeRegisterList />,
      },
      {
        title: trans('PERSONAL_DATA_ACCESS.TAB.TITLE.BROWSER_PRINT'),
        key: 'browserPrint',
        content: <BrowserPrinterList />,
      },
      {
        title: trans('PERSONAL_DATA_ACCESS.TAB.TITLE.DATA_CHANGE_REGISTER'),
        key: 'dataChangeRegister',
        content: <UserPersonalDataChangeRegisterList />,
      },
    ];
  }, []);

  return (
    <Fragment>
      <Breadcrumb label={trans('BREADCRUMB.REPORTS.ACCESS_LIST')} static />
      <Page title={trans('PERSONAL_DATA_ACCESS.LIST')}>
        <Paper innerSpacing={2} outerSpacing={[0, 2, 2]} className={classes.paper}>
          <TabPanel tabs={tabs} defaultTab={'studentChildRegister'} />
        </Paper>
      </Page>
    </Fragment>
  );
};
